import { render } from "./EditTypeConsultation.vue?vue&type=template&id=a9cada78&scoped=true"
import script from "./EditTypeConsultation.vue?vue&type=script&lang=js"
export * from "./EditTypeConsultation.vue?vue&type=script&lang=js"

import "./EditTypeConsultation.vue?vue&type=style&index=0&id=a9cada78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9cada78"]])

export default __exports__